import Box from "@material-ui/core/Box";
import React from "react";
import { useRecordContext } from "react-admin";

import { BoxMovementsGrid } from "../../components/BoxMovementsGrid";

export const PalletBoxMovementsDetails = ({ translate, terminalId, storagePlaces }) => {
	const record = useRecordContext();

	return (
		<Box px={10} py={0.2}>
			<BoxMovementsGrid
				translate={translate}
				pallet={record}
				terminalId={terminalId}
				storagePlaces={storagePlaces}
			/>
		</Box>
	);
};
